import React, { useRef, useEffect } from 'react';
import styled from '@emotion/styled';
import theme from '../../constants/theme';
import Mq from '../../utils/mq';
const Container = styled.div `
  position: fixed;
  bottom: 0px;
  right: 0px;
  z-index: 1000;
  ${Mq(2)} {
    width: 250px;
    height: 250px;
  }
`;
const FakeButton = styled(({ color, ...rest }) => React.createElement("div", Object.assign({}, rest))) `
  background-color: ${props => props.color};
  width: ${theme.space.xl}px;
  height: ${theme.space.xl}px;
  border-radius: ${theme.space.xl}px;
  z-index: 1050;
  box-shadow: 0px 3px 31px -15px rgba(0, 0, 0, 0.75);
  position: fixed;
  bottom: 40px;
  right: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-height: 740px) {
    bottom: 10px;
    right: 20px;
  }
`;
/**
 * FakeHelpScoutButton will handle an optimization to not load 'HelpScout'
 * on initial load so this causes the website to increase its performance
 * @param onInitHelpScout This function initializes the HelpScout **
 * @param color Color to set the HelpScout button default **
 * @param timerToStart should be send in seconds
 */
const FakeHelpScoutButton = ({ onInitHelpScout, color = '#527ceb', timerToStart = 1 }) => {
    const refButton = useRef(null);
    const removeButton = () => {
        const node = refButton.current;
        node === null || node === void 0 ? void 0 : node.remove();
    };
    const onInit = () => {
        if (process.env.NODE_ENV === 'test')
            return;
        onInitHelpScout && onInitHelpScout(removeButton);
    };
    useEffect(() => {
        if (onInitHelpScout) {
            /**
             * Timer allow us to make differents test
             */
            const timer = setTimeout(() => {
                onInit();
            }, timerToStart * 1000);
            return () => clearTimeout(timer);
        }
        // This return its just to make ts happy
        return () => null;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [onInitHelpScout]);
    return (React.createElement(Container, { ref: refButton, onMouseEnter: onInit },
        React.createElement(FakeButton, { color: color },
            React.createElement("svg", { width: "24", height: "22", xmlns: "http://www.w3.org/2000/svg", "aria-label": "message icon" },
                React.createElement("path", { d: "M20.347 20.871l-.003-.05c0 .017.001.034.003.05zm-.243-4.278a2 2 0 0 1 .513-1.455c1.11-1.226 1.383-2.212 1.383-4.74C22 5.782 18.046 2 13.125 2h-2.25C5.954 2 2 5.78 2 10.399c0 4.675 4.01 8.626 8.875 8.626h2.25c.834 0 1.606-.207 3.212-.798a2 2 0 0 1 1.575.083l2.355 1.161-.163-2.878zM10.875 0h2.25C19.13 0 24 4.656 24 10.399c0 2.6-.25 4.257-1.9 6.08l.243 4.279c.072.845-.807 1.471-1.633 1.162l-3.682-1.816c-1.212.446-2.527.921-3.903.921h-2.25C4.869 21.025 0 16.142 0 10.4 0 4.656 4.869 0 10.875 0z", fill: "#FFF" })))));
};
export default FakeHelpScoutButton;
//# sourceMappingURL=fake-help-scout-button.js.map